import { h, render } from 'vue';

class VueTooltip {
  constructor() {
    this.availableTriggers = ['click', 'hover', 'focus', 'manual'];
  }

  create(el, binding, { props }) {
    const $el = $(el);
    const trigger = this.getTrigger(binding);
    const { title, isHtml: htmlFromComponent } = resolveTitle(binding.value ?? props.title ?? '');
    const isHtml = binding.modifiers.html ?? htmlFromComponent;

    const placement = binding.arg || 'top';

    $el.tooltip({
      title,
      placement,
      boundary: 'window',
      trigger,
      html: isHtml,
    });

    trigger.indexOf('click') === -1 && $el.on('click', () => $el.tooltip('hide'));
  }

  getTrigger(binding) {
    return this.hasTriggerModifiers(binding) ? this.buildTrigger(binding) : 'hover focus';
  }

  hasTriggerModifiers(binding) {
    for (const trigger of this.availableTriggers) {
      if (binding.modifiers[trigger]) {
        return true;
      }
    }

    return false;
  }

  buildTrigger(binding) {
    const t = [];

    for (const trigger of this.availableTriggers) {
      if (binding.modifiers[trigger]) {
        t.push(trigger);
      }
    }

    return t.join(' ');
  }

  renderComponentToHtml(component, componentProps = {}) {
    const container = document.createElement('div');
    const vnode = h(component, componentProps);

    render(vnode, container);

    const html = container.innerHTML;

    render(null, container);
    container.remove();

    return html;
  }

  static destroy(el) {
    $(el).tooltip('dispose');
  }
}

const tooltip = new VueTooltip();

function resolveTitle(value) {
  if (typeof value === 'object' && value) {
    const component = value.component ?? value;
    const componentProps = value.props ?? {};
    return {
      title: tooltip.renderComponentToHtml(component, componentProps),
      isHtml: true,
    };
  }

  return {
    title: value ?? '',
    isHtml: false,
  };
}

export const create = (el, binding, vNode) => {
  if (!Object.prototype.hasOwnProperty.call(binding, 'value') || !binding.value) {
    return;
  }

  tooltip.create(el, binding, { props: vNode.props ?? {} });
};

export const update = (el, binding, vNode) => {
  if (!Object.prototype.hasOwnProperty.call(binding, 'value') || !binding.value) {
    $(el).tooltip('dispose');
    return;
  }

  if (!$(el).data('bs.tooltip')) {
    tooltip.create(el, binding, vNode);
    return;
  }

  const { title: newTitle } = resolveTitle(binding.value);
  $(el).attr('data-original-title', newTitle);
};

export const beforeUnmount = el => VueTooltip.destroy(el);
